import * as React from 'react';

// Components
import GenericNavbar from '@shopee-user/generic-navbar';
import IconNavBack24 from '../Icons/IconNavBack';

import styles from './style.scss';

type Props = {
  title?: string;
  rightContent?: React.ReactNode;

  onClickBack?: (event: React.SyntheticEvent) => void;
  shouldHideBack?: boolean;
  isResponsive?: boolean;
};

const Navbar = (props: Props): JSX.Element => {
  return (
    <GenericNavbar
      {...props}
      containerClassName={styles.container}
      icon={IconNavBack24}
      titleClassName={styles.title}
    />
  );
};

export default Navbar;
